import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import type {
  BotListObject,
  BotObject,
  ChatListObject,
  MessageListObject,
  NewBotObject,
  TelegramBotStatus,
} from "./types";
import { appBotApi, appTelegramApi } from "../../config/apiConfig";

export const getBots = (): Promise<BotListObject> => {
  return appBotApi
    .get("/v1/bots", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const createBot = (postObj: NewBotObject): Promise<BotObject> => {
  return appBotApi
    .post("/v1/bots", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getBot = (ref: string): Promise<BotObject> => {
  return appBotApi
    .get("/v1/bots/" + ref, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const updateBot = (
  ref: string,
  postObj: BotObject,
): Promise<BotObject> => {
  return appBotApi
    .post("/v1/bots/" + ref, postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const deleteBot = (ref: string): Promise<string> => {
  return appBotApi
    .delete("/v1/bots/" + ref, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getBotChats = (ref: string): Promise<ChatListObject> => {
  return appBotApi
    .get("/v1/bots/" + ref + "/chats", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const updateChatAssistantName = (
  ref: string,
  chat_id: string,
  postObj: { asst_name: string },
): Promise<string> => {
  return appBotApi
    .post("/v1/bots/" + ref + "/chats/" + chat_id, postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getChatMessages = (
  ref: string,
  chat_id: string,
): Promise<MessageListObject> => {
  return appBotApi
    .get("/v1/bots/" + ref + "/chats/" + chat_id + "/messages", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const verifyBot = (token: string): Promise<TelegramBotStatus> => {
  return appTelegramApi
    .get("/bot" + token + "/getMe", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
